<ngb-carousel 
  class="carousel-class"
  *ngIf="noticiasCargadas || hayNoticias"
  [interval]="intervalo"
  (slide)="onSlide($event)"
  [pauseOnHover]="true"
  [showNavigationIndicators]="true"
>

  <ng-template ngbSlide [id]="'slide-' + i" *ngFor="let item of noticias; let i = index">
    
    <img 
      class="d-block w-100"
      [src]="shouldLoad(i) ? files + item.nombreImagen : null"
      [alt]="item.titulo"
      (click)="verImagen()"
      loading="lazy"
      decoding="async"
    >

  </ng-template>

</ngb-carousel>
